import { Theme, Typography, useMediaQuery } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React from 'react';
import { CHARCOAL_GREY, WHITE } from '../../Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';
import { Avatar } from '..';

const useStyles = (
  fontSize: number,
  maxWidth: number | string,
  color: string,
  bgColor: string,
  textCenter: boolean | undefined,
) =>
  makeStyles(() => ({
    title: {
      flexGrow: 1,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      maxWidth: 'calc(100% - 30px)',
    },
    displayName: {
      fontWeight: 'bold',
      fontSize,
      marginTop: textCenter ? 5 : 0,
      maxWidth,
      marginLeft: textCenter ? 0 : 10,
    },
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      overflow: 'hidden',
      flexDirection: textCenter ? 'column' : 'row',
    },
    titleWithIcon: {
      display: 'flex',
      alignItems: 'center',
    },
    arrowDown: {
      fontSize: 23,
      color: CHARCOAL_GREY,
    },
    avatar: {
      color,
      backgroundColor: bgColor,
      fontWeight: 'normal',
    },
  }));

export interface StyleProps {
  fontSize: number;
  maxWidth: number | string;
  color: string;
  bgColor: string;
  textCenter?: boolean;
}

export interface IProfilePictureCardProps {
  hasArrowDown?: boolean;
  responsiveLabel?: boolean;
  fontSize?: number;
  imageSize?: number;
  imageUrl?: string;
  displayName: string;
  maxWidth?: number;
  color?: string;
  bgColor?: string;
  textCenter?: boolean;
  actionButton?: React.ReactNode;
  hideLabel?: boolean;
  imageContainerClass?: string;
}

export const ProfilePictureCard = (props: IProfilePictureCardProps) => {
  const {
    hasArrowDown,
    responsiveLabel,
    imageSize = 30,
    fontSize = 12,
    imageUrl,
    displayName,
    maxWidth = '100%',
    color = WHITE,
    bgColor = CHARCOAL_GREY,
    textCenter,
    actionButton,
    hideLabel,
    imageContainerClass = '',
  } = props;
  const { classes } = useStyles(fontSize, maxWidth, color, bgColor, textCenter)();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  return (
    <div className={classes.root}>
      <div className={imageContainerClass}>
        <Avatar
          className={classes.avatar}
          imageUrl={imageUrl}
          name={displayName}
          size={imageSize}
        />
        {actionButton}
      </div>
      {!hideLabel && (
        <div className={classes.title}>
          <div className={classes.titleWithIcon}>
            {!(isMobile && responsiveLabel) && (
              <Typography align="left" className={classes.displayName} noWrap variant="subtitle1">
                {displayName}
              </Typography>
            )}
            {hasArrowDown && <KeyboardArrowDownIcon className={classes.arrowDown} />}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfilePictureCard;
